import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../../assets/images/footer_logo.png";
import facebookIcon from "../../assets/images/Facebook.svg";
import twitterIcon from "../../assets/images/Twitter.svg";
import instagramIcon from "../../assets/images/Instagram.svg";
import linkedinIcon from "../../assets/images/LinkedIn.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <hr />
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <img src={logo} alt="Lingify" className="footer-logo" />
            <p className="footer-description">
              Dil ve konuşma bozukluklarına yönelik güncel çalışmalar ve bizden
              haberleri almak için bültenimize kaydolabilirsiniz.{" "}
            </p>
            <div className="newsletter">
              <h3 className="newsletter-title">
                Yeni haber ve bilgi almak için;
              </h3>
              <div className="newsletter-form">
                <input
                  type="email"
                  placeholder="E-mail"
                  className="newsletter-input"
                />
                <button className="newsletter-button">Abone Ol</button>
              </div>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column column1">
              <Link to="/" className="nav-link">
                Ana Sayfa
              </Link>
              <Link to="/hakkimizda" className="nav-link">
                Hakkımızda
              </Link>
              <Link to="/blog" className="nav-link">
                Blog
              </Link>
              <Link to="/kvkk" className="nav-link">
                KVKK
              </Link>
              <Link to="/aydinlatma-metni" className="nav-link">
                Aydınlatma Metni
              </Link>
              <Link to="/gizlilik" className="nav-link">
                Gizlilik Sözleşmesi
              </Link>
              <Link to="/kullanici-sozlesmesi" className="nav-link">
                Kullanıcı Sözleşmesi
              </Link>
              <Link to="/cerez-politikasi" className="nav-link">
                Çerez Politikası
              </Link>
            </div>
            <div className="footer-column column2">
              <Link to="/vizyon" className="nav-link">
                Vizyon & Misyon
              </Link>
              <Link to="/degerlerimiz" className="nav-link">
                Değerlerimiz
              </Link>
              <Link to="/hikayemiz" className="nav-link">
                Hikayemiz
              </Link>
              <Link to="/sss" className="nav-link">
                Sık Sorulan Sorular
              </Link>
              <Link to="/brodmann" className="nav-link">
                Topluluğumuz
              </Link>
              <Link to="/iletisim" className="nav-link">
                Bize Ulaşın!
              </Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>
              Copyright © 2025 lingify.co | Bütün hakları Saklıdır |{" "}
              <Link to="/kullanici-sozlesmesi">Şartlar ve Koşullar</Link> |{" "}
              <Link to="/gizlilik">Gizlilik Sözleşmesi</Link> |{" "}
              <Link to="/kvkk">KVKK</Link>
            </p>
          </div>

          <div className="social-icons">
            <Link
              to="https://www.facebook.com/profile.php?id=61554485875953"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebookIcon} alt="Facebook" />
            </Link>
            <Link
              to="https://x.com/lingify_co"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={twitterIcon} alt="Twitter" />
            </Link>
            <Link
              to="https://www.instagram.com/lingify.co/"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagramIcon} alt="Instagram" />
            </Link>
            <Link
              to="https://www.linkedin.com/company/lingify/"
              className="social-icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedinIcon} alt="LinkedIn" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
